import styled from "styled-components";

const SkeletonWrapper = styled.div`
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "100%"};
  border-radius: 50%;
  background: linear-gradient(
    90deg,
    rgb(75, 75, 75) 0%,
    rgb(121, 120, 120) 50%,
    rgb(71, 71, 71) 100%
  );
  background-size: 200% 100%;
  animation: gradient 1.5s ease-in-out infinite;
  position: absolute;
  top: 0;
  left: -1px;
  transition: all 0.3s ease-in-out;
   opacity: ${(props) => (props.hidden ? 0 : 1)};
  display: block; /* Zapobiega przesunięciom inline-block */
  pointer-events: none; /* Zapobiega przechwytywaniu kliknięć */
  z-index: 2; /* Niższy niż ProfileImage */
  @media (max-width: ${(props) => props.theme.breakpoint.mobileMax}px) {
    width: ${(props) => (props.width === "36px" ? "27px" : props.width)};
    height: ${(props) => (props.height === "36px" ? "27px" : props.height)};
  }
  @keyframes gradient {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
`;

const ImageSkeleton = ({ width, height, hidden }) => {
  return <SkeletonWrapper width={width} height={height} hidden={hidden} />;
};

export default ImageSkeleton;